<template>
    <v-snackbar
        v-model="visible"
        max-width="520"
        :timeout="current?.duration"
        :color="snackbarColor"
        @after-leave="dismiss()">
        <div class="d-flex align-center ga-5">
            <v-icon size="16" :icon="snackbarIcon" />
            <span class="text-body-1">{{ current?.message }}</span>
        </div>
    </v-snackbar>
</template>

<script setup lang="ts">
import { computed, nextTick, ref, watch } from "vue"
import { storeToRefs } from "pinia"
import { useNotificationStore } from "@/store/core/notification"

const notificationStore = useNotificationStore()
const { current } = storeToRefs(notificationStore)
const { dismiss } = notificationStore

const visible = ref(false)

watch(
    current,
    (val, oldVal) => {
        if (!val) {
            visible.value = false
        } else if (oldVal) {
            visible.value = false
            nextTick(() => {
                visible.value = true
            })
        } else {
            visible.value = true
        }
    },
    { immediate: true }
)

const snackbarColor = computed(() => (current.value?.type === "error" ? "red-darken-3" : "green-darken-4"))

const snackbarIcon = computed(() => (current.value?.type === "error" ? "mdi-alert-circle" : "mdi-check-circle"))
</script>
